import { mapActions, mapGetters, mapMutations } from 'vuex';
import graphql from '@/mixins/graphql';
import webChats from '@/mixins/webChats';
import externalAuthorization from '@/mixins/externalAuthorization';
import userAppData from '@/mixins/userAppData';
import profileDialogs from '@/mixins/profileDialogs';
import dashboardPartnerData from '@/mixins/dashboardPartnerData.js';

const SESSION_TIMEOUT_MS = 1000 * 60 * 60 * 8;

export default {
  mixins: [
    graphql,
    webChats,
    externalAuthorization,
    userAppData,
    profileDialogs,
    dashboardPartnerData
  ],

  data: () => ({
    logoutTimer: null
  }),
  computed: {
    ...mapGetters('profile/dashboard', ['dashboardGtmSent'])
  },

  beforeDestroy() {
    this.clearTimers();
    this.removeEventListeners();
  },

  methods: {
    ...mapActions('profile/dashboard', ['updatePartner']),
    ...mapMutations('profile/dashboard', [
      'setPartnerData',
      'setLoadingPartnerData',
      'setDashboardGtmSent'
    ]),

    clearTimers() {
      clearTimeout(this.logoutTimer);
    },

    setupEventListeners() {
      if (this.isMobileApp) {
        return;
      }

      ['mousemove', 'mouseup', 'keyup'].forEach(evt => {
        document.addEventListener(evt, this.markActivity);
      });
    },

    removeEventListeners() {
      ['mousemove', 'mouseup', 'keyup'].forEach(evt => {
        document.removeEventListener(evt, this.markActivity);
      });
    },

    async loadPartner() {
      if (this.$auth.user && this.$auth.user?.benefit?.partnerUrl) {
        await this.updatePartner({
          partnerUrl: this.$auth.user.benefit.partnerUrl,
          region: this.$domainRegion
        });
      } else {
        this.setPartnerData({});
        this.setLoadingPartnerData(false);
      }
    },

    resetLogoutTimer() {
      clearTimeout(this.logoutTimer);
      this.logoutTimer = setTimeout(() => this.logout(), SESSION_TIMEOUT_MS);
    },

    markActivity() {
      this.resetLogoutTimer();
    },

    async profileLayoutSetupInit() {
      await Promise.all([
        this.loadPartner(),
        this.$route.query.rk ? this.$auth.fetchUser() : Promise.resolve()
      ]);

      this.setupEventListeners();

      await this.checkExternalAuthorization();
      await this.activateExternalBenefit();

      if (!this.dashboardGtmSent) {
        this.trackGtmEvent();
      }
    },

    trackGtmEvent() {
      this.gtmPush({
        hrbName: this.partnerData?.name,
        siteSection: 'klientska_zona',
        user_type: this.$auth.user?.benefit?.active ? 'b2b' : 'b2c'
      });
      this.setDashboardGtmSent(true);
    }
  }
};
